module.exports = __webpack_public_path__ + "static/media/fix.92dd9df8.svg";